import { Vector3 } from '@babylonjs/core';
import { ICharacterInput } from './Character';

export class SwitchableInput implements ICharacterInput {
  constructor(private current: ICharacterInput) {}

  setCurrent(current: ICharacterInput): void {
    this.current = current;
  }

  getCurrent(): ICharacterInput {
    return this.current;
  }

  getMovementInput(): number {
    return this.current.getMovementInput();
  }

  getVerticalInput(): number {
    return this.current.getVerticalInput();
  }

  isJumpPressed(): boolean {
    return this.current.isJumpPressed();
  }

  isAttackPressed(): boolean {
    return this.current.isAttackPressed();
  }

  getCameraForward(): Vector3 {
    return this.current.getCameraForward();
  }

  getCameraRight(): Vector3 {
    return this.current.getCameraRight();
  }
}
